// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1J8cD","icon":"styles_icon__1eM3i"};